'use strict';
'use es6';

// These should be removed once we have 100% adoption of UIApplication

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('../listeners/focusStylesListener');

var _setupStyledComponents = require('../listeners/setupStyledComponents');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _Functions = require('../core/Functions');

var _ShareButton = require('../decorators/ShareButton');

var _ShareButton2 = _interopRequireDefault(_ShareButton);

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _TabIndex = require('../utils/TabIndex');

var _ClickableContext = require('../context/ClickableContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(0, _setupStyledComponents.setupStyledComponents)();

var UIClickable = function (_React$Component) {
  _inherits(UIClickable, _React$Component);

  function UIClickable(props) {
    _classCallCheck(this, UIClickable);

    var _this = _possibleConstructorReturn(this, (UIClickable.__proto__ || Object.getPrototypeOf(UIClickable)).call(this, props));

    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(UIClickable, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          autoFocus = _props.autoFocus,
          buttonRef = _props.buttonRef;

      if (autoFocus) {
        if (buttonRef.current) buttonRef.current.focus();
      }
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(evt) {
      var key = evt.key,
          target = evt.target;
      var _props2 = this.props,
          buttonRef = _props2.buttonRef,
          disabled = _props2.disabled,
          onClick = _props2.onClick,
          onKeyDown = _props2.onKeyDown;


      (0, _Functions.callIfPossible)(onKeyDown, evt);

      if (target !== buttonRef.current) return;

      // Simulate click on Enter/Spacebar, to emulate button behavior
      if (key === 'Enter' || key === ' ') {
        if (disabled) {
          evt.preventDefault();
          evt.stopPropagation();
          return;
        }
        (0, _Functions.callIfPossible)(onClick, evt);
        if (key === ' ') {
          evt.preventDefault(); // Prevent page from scrolling (#3575)
        }
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(evt) {
      var _props3 = this.props,
          disabled = _props3.disabled,
          onClick = _props3.onClick;


      if (disabled) {
        evt.preventDefault();
        evt.stopPropagation();
        return;
      }

      (0, _Functions.callIfPossible)(onClick, evt);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          buttonRef = _props4.buttonRef,
          className = _props4.className,
          __cursor = _props4.cursor,
          disabled = _props4.disabled,
          __onClick = _props4.onClick,
          __onKeyDown = _props4.onKeyDown,
          tabIndex = _props4.tabIndex,
          Tag = _props4.tagName,
          rest = _objectWithoutProperties(_props4, ['buttonRef', 'className', 'cursor', 'disabled', 'onClick', 'onKeyDown', 'tabIndex', 'tagName']);

      return _react2.default.createElement(Tag, _extends({}, rest, {
        'aria-disabled': disabled,
        className: (0, _classNames2.default)('private-clickable', className),
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        ref: (0, _Functions.wrapRefObject)(buttonRef),
        tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex, null)
      }));
    }
  }]);

  return UIClickable;
}(_react2.default.Component);

UIClickable.displayName = 'UIClickable';

var StyledClickable = (0, _styledComponents2.default)(UIClickable).withConfig({
  displayName: 'UIClickable__StyledClickable'
})(['cursor:', ';'], function (_ref) {
  var cursor = _ref.cursor,
      disabled = _ref.disabled;
  return disabled ? 'not-allowed' : cursor;
});

var UIClickableWithProviders = function (_React$Component2) {
  _inherits(UIClickableWithProviders, _React$Component2);

  function UIClickableWithProviders(props) {
    _classCallCheck(this, UIClickableWithProviders);

    var _this2 = _possibleConstructorReturn(this, (UIClickableWithProviders.__proto__ || Object.getPrototypeOf(UIClickableWithProviders)).call(this, props));

    _this2.getPortalReporterDetails = _this2.getPortalReporterDetails.bind(_this2);
    return _this2;
  }

  _createClass(UIClickableWithProviders, [{
    key: 'getPortalReporterDetails',
    value: function getPortalReporterDetails() {
      var buttonRef = this.props.buttonRef;

      var buttonEl = buttonRef.current;
      return {
        componentName: UIClickable.displayName,
        labelText: buttonEl && buttonEl.innerText
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _ClickableContext.ClickableContextProvider,
        {
          value: (0, _ClickableContext.makePortalReporter)(this.getPortalReporterDetails)
        },
        _react2.default.createElement(StyledClickable, this.props)
      );
    }
  }]);

  return UIClickableWithProviders;
}(_react2.default.Component);

UIClickableWithProviders.propTypes = {
  autoFocus: _react.PropTypes.bool,
  buttonRef: _refObject2.default,
  cursor: _react.PropTypes.string,
  disabled: _react.PropTypes.bool,
  tagName: _react.PropTypes.string.isRequired
};

UIClickableWithProviders.defaultProps = {
  cursor: 'pointer',
  role: 'button',
  tagName: 'div'
};

// Expose the inner component for tests
UIClickableWithProviders.CoreComponent = UIClickable;
UIClickableWithProviders.WrappedComponent = UIClickable;
UIClickableWithProviders.displayName = 'UIClickableWithProviders';

exports.default = (0, _ShareButton2.default)(UIClickableWithProviders);
module.exports = exports['default'];